export const LS_RECENT_USAGE_KEY = '__LS_RECENT_USAGE_KEY__';
export const LS_IS_DARK_MODE_KEY = '__LS_IS_DARK_MODE_KEY__';
